import apiClient from "../apiClient";
import API_ENDPOINTS from "../endpoints";
import apiClientWithoutInterceptors from "../plainApiClient";

const loginService = {
  userLogin: (body) => {
    return apiClient.post(API_ENDPOINTS.LOGIN_USER, body);
  },
  userLoginData: () => {
    return apiClient.get(API_ENDPOINTS.LOGIN_USER_DATA);
  },
  userLogout: (body) => {
    return apiClient.post(API_ENDPOINTS.LOGOUT_USER, body);
  },
  silentLogout: (body) => {
    return apiClientWithoutInterceptors.post(API_ENDPOINTS.LOGOUT_USER, body);
  },
  changePassword: (body) => {
    return apiClient.patch(API_ENDPOINTS.NEW_PASSWORD, body);
  },
  forgetPassword: (body) => {
    return apiClient.post(API_ENDPOINTS.FORGOT_PASSWORD, body);
  },
  validateCode: (body) => {
    return apiClient.post(API_ENDPOINTS.VALIDATE_CODE, body);
  },
  resetPassword: (body) => {
    return apiClient.post(API_ENDPOINTS.RESET_PASSWORD, body);
  },
  setPassword: (params) => {
    const { userId, body } = params;
    const url = `/user-access/users/${userId}/reset-password`;
    return apiClient.post(url, body);
  },
};

export default loginService;
